import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

import expirationDates from '@/store/shared/due-dates'

export default {
  namespaced: true,
  state() {
    return {
      paymentType: null,
      iban: undefined,
      beneficiaryName: undefined,
      beneficiaryAddress: undefined
    }
  },
  getters,
  mutations,
  actions,
  modules: {
    expirationDates
  }
}
